import { ReactNode, useEffect, useState } from "react";

import { OrderButtonContextProvider } from "@/components/Product/ECommerce/components/orderButton/context/orderButton.context";
import { useECommerceContext } from "@/components/Product/ECommerce/context/eCommerce.context";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

import { useActionHandlerContext } from "../../context/actionHandler.context";
import { useProductConfigurationContext } from "../../context/productConfiguration.context";
import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { useProductDetail } from "../../hooks/useProductDetail.hook";

type Props = {
    children: ReactNode;
};

export const Base = ({ children }: Props) => {
    const [isDisabled, setIsDisabled] = useState(true);
    const isClientSide = useIsClientSide();

    const { isConfigurationValid } = useProductConfigurationContext();
    const { onSubmit } = useActionHandlerContext();
    const { isEcommerceReady } = useECommerceContext();
    const { quantity } = useProductDetail();
    const { isBoxSoldOut, montageParents, sku } = useECommerceProduct();

    useEffect(() => {
        const canSubmit = sku !== "" && quantity > 0;

        setIsDisabled(
            !canSubmit ||
                !isEcommerceReady ||
                !isConfigurationValid ||
                isBoxSoldOut ||
                montageParents.length > 0
        );
    }, [
        isBoxSoldOut,
        isEcommerceReady,
        isConfigurationValid,
        sku,
        quantity,
        montageParents
    ]);

    return (
        <OrderButtonContextProvider
            isDisabled={!isClientSide || isDisabled}
            onSubmit={onSubmit}
        >
            {children}
        </OrderButtonContextProvider>
    );
};
